import { render, staticRenderFns } from "./ImgPreview.vue?vue&type=template&id=a8dcd294&scoped=true&"
import script from "./ImgPreview.vue?vue&type=script&lang=js&"
export * from "./ImgPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImgPreview.vue?vue&type=style&index=0&id=a8dcd294&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dcd294",
  null
  
)

export default component.exports